// extracted by mini-css-extract-plugin
module.exports = {"content":"display-symbol_content__ULr7C"};